import React from 'react'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import { Container } from '@mui/material'
import { addNewBaseTax, updateBaseTax } from '../../store/actions/baseTaxAction'

const validationSchema = Yup.object().shape({
    taxLabel: Yup.string().required().label('Tax Label'),
    taxRate: Yup.number().required().label('Tax Rate'),
})

const BaseTaxForm = ({ formType, setOpen, propsValue = null }) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } BASE TAX`}
            />
            <AppForm
                initialValues={{
                    taxLabel: propsValue ? propsValue.taxLabel : '',
                    taxRate: propsValue ? propsValue.taxRate : '',
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? values
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(addNewBaseTax(submitValues))
                        : dispatch(updateBaseTax(submitValues))
                    setOpen(false)
                }}
                validationSchema={validationSchema}
            >
                <AppInput
                    name="taxLabel"
                    label="Tax Label"
                    type="text"
                    inputProps={{
                        maxLength: 20,
                    }}
                    required={true}
                />
                <AppInput
                    name="taxRate"
                    label="Tax Rate"
                    type="number"
                    inputProps={{
                        maxLength: 10,
                    }}
                    required={true}
                />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default BaseTaxForm
